import { JiraIntegration } from './JiraIntegration';
import React from 'react';
import { ViewArea } from '@ui/general';

export const Jira: React.FC = () =>
	<ViewArea
		direction='vertical'
		fullHeight
		fullWidth
		id='jira'>
		<JiraIntegration />
	</ViewArea>;

